/**
 * External Dependencies
 */
import 'jquery';
import 'jquery-inline-svg';
import 'flickity/dist/flickity.pkgd.min.js';

import './lib/menu';
// import './lib/newsletter';


$(document).ready(() => {

  var $findme = $('.aaa-numbers');
  var exec = false;
  function Scrolled() {
    $findme.each(function() {
      var $section = $(this),
        findmeOffset = $section.offset(),
        findmeTop = findmeOffset.top,
        findmeBottom = $section.height() + findmeTop,
        scrollTop = $(document).scrollTop(),
        visibleBottom = window.innerHeight,
        prevVisible = $section.prop('_visible');

      if ((findmeTop > scrollTop + visibleBottom) ||
        findmeBottom < scrollTop) {
        var visible = false;
      } else {
        var visible = true;
      }

      if (!prevVisible && visible) {
        if(!exec){
          $('.number').each(function() {
            $(this).prop('Counter', 0).animate({
              Counter: $(this).text()
            }, {
              duration: 4000,

              step: function(now) {
                $(this).text(Math.ceil(now));
                exec = true;
              }
            });
          });
        }
      }
      $section.prop('_visible', visible);
    });
  }

  function Setup() {
    var $top = $('#top'),
      $bottom = $('#bottom');

    $top.height(500);
    $bottom.height(500);

    $(window).scroll(function() {
      Scrolled();
    });
  }

  Setup();

  // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  //   anchor.addEventListener('click', function (e) {
  //     e.preventDefault();
  //
  //     document.querySelector(this.getAttribute('href')).scrollIntoView({
  //       behavior: 'smooth'
  //     });
  //   });
  // });



  $('.numbers-container').flickity({
    arrowShape: 'M49.2953615,24 L53.7138346,28.4203615 L34.965625,47.1607396 L77.4194173,47.1607396 L77.4194173,53.4100722 L34.965625,53.4100722 L53.7138346,72.1600722 L49.2953615,76.5794896 C32.1024298,59.3902303 23.3373093,50.6269821 23,50.2897448 L49.2953615,24 Z',
    adaptiveHeight: false,
    contain: true,
    draggable: true,
    imagesLoaded: true, // re-positions cells once their images have loaded
    groupCells: true, // group cells that fit in carousel viewport
    cellAlign: 'left',
    freeScroll: false,
    wrapAround: false,
    watchCSS: true,
  });


  $('.clients-container').flickity({
    adaptiveHeight: false,
    autoPlay: 1500,
    draggable: true,
    imagesLoaded: true, // re-positions cells once their images have loaded
    groupCells: true,
    cellAlign: 'left',
    freeScroll: false,
    wrapAround: 'carousel',
    pageDots: false,
  });


  // Turn img to inline svg
  $('[data-inline-svg]').inlineSvg();


  // breakpoints
  var x = window.matchMedia('(max-width: 768px)')
  responsiveMedia(x) // Call listener function at run time
  x.addListener(responsiveMedia)

  function responsiveMedia(x) {

    if (x.matches) { // If media query matches

    } else {

    }
  }
});



// smooth scroll to anchor
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});



$(window).load(() => {

  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

});
